import React from 'react';
import ParafiaWizytowka from './ParafiaWizytowka';

function App() {
  return (
    <div className="App">
      <ParafiaWizytowka />
    </div>
  );
}

export default App;